<div class="min-h-screen bg-white md:bg-transparent">

  <!-- Background only for desktop -->
  <div class="md:min-h-screen md:bg-[url('/assets/images/bg-img.jpg')]
           md:bg-no-repeat md:bg-center md:bg-cover md:py-10">

    <!-- Card wrapper (mobile = full, desktop = centered card) -->
    <!-- class="p-8 w-full min-h-screen md:p-4 md:min-h-[650px] -->
    <div class="w-full min-h-screen md:min-h-[650px]
             md:max-w-md md:rounded-2xl md:bg-white
             md:overflow-y-auto md:m-auto">

      <!-- Scrollable Content -->
      <header class="w-full h-12 flex items-center bg-[var(--primary-color)] py-8 px-4">
  
        <!-- Back Button -->
        <button
          (click)="_loginStep.prevStep()"
          type="button"
          class="rounded-full p-1 cursor-pointer"
        >
          <img class="w-8 h-8" src="assets/images/back.webp" />
        </button>
      
        <!-- Center Logo -->
        <div class="flex-1 flex justify-center">
          <img class="w-32" src="assets/SVG/company_logo.svg" />
        </div>
      
        <!-- Right Spacer -->
        <div class="w-8"></div>
      
      </header>
      

      <app-global-loader />
      <router-outlet />
      <app-toast-container />

    </div>
  </div>
</div>

@if (isLangPopUpVisible()) {
<app-language-modal [isPopUpVisible]="isLangPopUpVisible" />
}